import {
  NgModule,
  NgZone,
} from '@angular/core';
import { UrlService } from '@uirouter/core';

import { PatientPortalAngularJSModule } from './ajs/ajs.module';
import { PatientPortalConfigurationRepository } from './core';
import {
  CoreModule,
  TelehealthModule,
} from './modules.index';

import {
  BridgeService,
  ConfigurationRepository,
  DeviceSettingsRepository,
  WebBridgeService,
  WebCommonModule,
} from 'webcommon';

@NgModule({
  imports: [
    WebCommonModule,
    CoreModule,
    PatientPortalAngularJSModule,
    TelehealthModule,
  ],
})
export class AppModule {
  constructor(
    private bridgeService: BridgeService,
    private configurationRepository: ConfigurationRepository,
    private deviceSettingsRepository: DeviceSettingsRepository,
    private ngZone: NgZone,
    private portalConfigurationRepository: PatientPortalConfigurationRepository,
    private urlService: UrlService,
    private webBridgeService: WebBridgeService,
  ) { }

  ngDoBootstrap() {
    this.configurationRepository.loadConfiguration(this.portalConfigurationRepository);
    this.deviceSettingsRepository.loadConfiguration({
      isBrowser: true,
      isBrowserOrOverride: true,
      isDevice: false,
      isDeviceOrOverride: false,
      isPhone: false,
      isPhoneOrOverride: false,
      isTablet: false,
      isTabletOrOverride: false,

      isAndroid: false,
      isIos: false,
      isPrm: false,
      isStandaloneBrowser: true,
    });
    this.bridgeService.loadConfiguration(this.webBridgeService);

    this.ngZone.run(() => {
      this.urlService.listen();
      this.urlService.sync();
    });
  }
}
